import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import { getScheduleMenuType } from 'utils';

const DEFAULT_CHANNEL = {
  id: 0,
  name: 'Please select a channel',
};

const useAccountStore = createWithEqualityFn((set) => ({
  user: {},
  setUser: (data) => set(() => ({ user: data })),
  isUserAuthenticated: false,
  isHydrated: false,
  setIsUserAuthenticated: (data) => set(() => ({ isUserAuthenticated: data })),
  organisationAdmin: (value) => {
    return value.roleId === 2;
  },
  setUserData: (data) => {
    set(() => ({
      user: {
        userId: data.userId,
        roleId: data.roleId,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        jobTitle: data.jobTitle,
        profilePic: data.profilePic,
        organisationBase64Logo: data.organisationBase64Logo,
        organisationId: data.organisationId,
        organisationName: data.organisationName,
        hasMultipleOrganisation: data.organisations.length > 1,
        organisations: data.organisations,
        clockType: data.clockType,
        activeFunction: null,
        channelId: null,
        channelName: null,
        timezone: null,
        endDate: null,
        menuItem: null,
        startDate: null,
        tab: null,
        gridState: null,
        schedulesMenuType: getScheduleMenuType(data.schedulesMenuType),
        selectedChannel: DEFAULT_CHANNEL,
        termsAccepted: data.termsAccepted,
      },
      isHydrated: true,
    }));
  },

  updateUser: (data) =>
    set((prev) => ({
      user: {
        ...prev.user,
        ...data,
      },
    })),

  updateChannel: (data) =>
    set((prev) => ({
      user: {
        ...prev.user,
        channelId: data.channelId,
        channelName: data.channelName,
        timezone: data.timezone,
      },
    })),

  updateSelectedChannel: (data) =>
    set((prev) => ({
      user: {
        ...prev.user,
        channelId: data.id,
        channelName: data.name,
        timezone: data.timezone,
        selectedChannel: { ...data },
      },
    })),
}));

const useStore = (callback) => useAccountStore(callback, shallow);

export default useStore;
